import { Shield } from "lucide-react"

/**
 * Platform Admin — статичный бренд-заголовок сайдбара, не переключаемая
 * сущность (в отличие от organization-admin, где здесь была бы текущая
 * организация пользователя).
 */
export function SidebarHeader() {
	return (
		<div className="flex items-center gap-2 pt-2 px-1">
			<Shield className="size-6" aria-hidden="true" />
			<span className="font-semibold">Platform Admin</span>
		</div>
	)
}
